import { signal } from "@preact/signals-react"

export const sessionSignal = signal(null)
export const sessionLoadedSignal = signal(false)
export const sessionErrorSignal = signal(null)
export const sessionExpirationTimestampSignal = signal(null)
export const sessionRefreshingSignal = signal(false)